var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.cssProps),attrs:{"id":"hero"}},[_c('div',{staticClass:"background-image"}),_c('div',{staticClass:"hero-content h-100"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }